import React, {ReactElement} from 'react';

const NotFound = (): ReactElement => {
  return (
    <div className="flex-centering">
      <h4>Page Not Found</h4>
    </div>
  );
};

export default NotFound;
